import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class ModuleAudio extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path
            d="M12.8,1.5l-7.4,1L5.1,2.8v7.5C4.8,10,4.4,9.8,3.9,9.8c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8V4.7l6.8-0.9
          v5.5c-0.3-0.3-0.7-0.5-1.2-0.5c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8V1.8L12.8,1.5z M3.9,12.8
          c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2C5.1,12.3,4.6,12.8,3.9,12.8z M5.7,4.1V3.1l6.8-0.9v1.1L5.7,4.1z
           M11.4,11.8c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2C12.6,11.3,12,11.8,11.4,11.8z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/ModuleAudio.js